// @flow

import { setProps } from '../props';
import initialize from '../Services/initialize';
import fetchProjects from '../../../Core/Services/fetchProjects';
import fetchProject from '../Services/fetchProject';

export default (props: any) => async (dispatch: Function) => {

  setProps(props);

  dispatch(initialize());

  await dispatch(fetchProjects());

  if (props.estimate || props.projectId) {
    await dispatch(fetchProject());
  }

  dispatch(initialize());
  
}